<div class="grid">
	<div class="col-12">
		<div class="card">
			<h5>Servicios</h5>
			<p-table
				#dt1
				[value]="services"
				dataKey="id"
				[rows]="10"
				[loading]="loading"
				[rowHover]="true"
				[paginator]="true"
				[globalFilterFields]="['name', 'price']"
				responsiveLayout="scroll"
			>
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<button
							pButton
							label="Limpiar"
							class="p-button-rounded mb-2"
							(click)="clear(dt1)"
						></button>
						<span class="p-input-icon-left">
							<i class="pi pi-circle-fill"></i>
							<input
								pInputText
								type="text"
								#filter
								(input)="dt1.filterGlobal($event.target.value, 'contains')"
								placeholder="Buscar"
								class="w-full"
							/>
						</span>
						<div class="text-right">
							<button 
							    *ngIf="getUser().role_id == 1"
								pButton
								pTooltip="Nuevo servicio"
								class="p-button-raised p-button-outlined m-1"
								icon="pi pi-plus"
								(click)="showDialog()"
							></button>
							<button
								pButton
								pRipple
								label="Actualizar"
								pTooltip="Actualizar servicios"
								type="button"
								icon="pi pi-refresh"
								class="p-button-raised p-button-outlined m-1"
								(click)="loadServices(); clear(dt1)"
							></button>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="header">
					<!-- HEADERS -->
					<tr>
						<th class="text-center">
							Imagen
						</th>
						<th class="text-center" pSortableColumn="name">
							<p-sortIcon field="name"></p-sortIcon>
							Nombre
						</th>
						<th class="text-center" pSortableColumn="price">
							<p-sortIcon field="price"></p-sortIcon>
							Precio
						</th>
						<th></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-service>
					<tr>
						<td class="text-center" style="max-width: 5rem">
							<img src="{{ service.image }}" class="img-rounded shadow-4" *ngIf="service.image">
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ service.name }}
							<i class="pi pi-fw pi-bookmark-fill" pTooltip="Seleccionado por defecto en reservas" *ngIf="service.is_default"></i>
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ service.price | currency: 'EUR' }}
						</td>
						<td class="text-center" style="min-width: 1rem">
							<button
								pButton
								pRipple
								type="button"
								pTooltip="Eliminar servicio"
								icon="pi pi-trash"
								class="p-button-danger p-button-raised p-button-outlined m-1"
								(click)="deleteService(service)"
							></button>
							<button
								pButton
								pRipple
								type="button"
								pTooltip="Editar servicio"
								icon="pi pi-pencil"
								class="p-button-raised p-button-outlined m-1"
								(click)="showDialog(service)"
							></button>
						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Sin resultados</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Cargando servicios...</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<!-- Modal recortador de imagen para creación-->
<p-dialog
	header="Recortador de imagen"
	[style]="{ width: '70vw' }"
	[(visible)]="cropping"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
>
	<div class="croppe">
		<image-cropper
			[imageChangedEvent]="imageChangedEvent"
			[maintainAspectRatio]="true"
			[aspectRatio]="1 / 1"
			format="jpeg"
			output="base64"
			(imageCropped)="imageCropped($event)"
			(imageLoaded)="imageLoaded($event)"
			(cropperReady)="cropperReady()"
			(loadImageFailed)="loadImageFailed()"
			class="cropper"
		></image-cropper>
	</div>
</p-dialog>

<!-- Modal para creación/edición servicio -->
<p-dialog
	header="Datos del servicio"
	[(visible)]="dialogService"
	[modal]="true"
	[style]="{ width: '80vw' }"
	[draggable]="false"
	[resizable]="false"
	(onHide)="resetForm()"
>
	<form [formGroup]="form">
		<div class="container-img">
			<div class="custom-file-upload" *ngIf="pictureCrop">
				<img [src]="pictureCrop" style="width: 220px" alt="Foto cargada" />
				<button
					class="ml-2"
					type="button"
					pButton
					icon="pi pi-trash"
					(click)="deleteMainPhoto()"
				></button>
			</div>
			<div class="custom-file-upload">
				<input
					id="photoInputImage"
					type="file"
					(change)="handleUploadPhoto($event)"
					accept=".jpg,.png"
				/>
				<label class="btn-img">Selecciona imagen principal</label>
			</div>
		</div>

		<div class="container-img">
			<div class="custom-file-upload">
				<input
					id="photoInputImage"
					type="file"
					#fileInput
					(change)="handleUpload()"
					accept=".jpg,.png"
					multiple="true"
				/>
				<label class="btn-img">Selecciona imágenes</label>
			</div>
		</div>
		<div class="preview-container">
			<div
				class="preview-image"
				*ngFor="let photo of stringPhoto; let i = index"
			>
				<img [src]="photo.image" alt="Imagen" />
				<button
					class="delete-button"
					type="button"
					pButton
					icon="pi pi-trash"
					(click)="deletePhotoCarrousel(photo.id, i)"
				></button>
			</div>
		</div>
		<div class="grid p-fluid mt-3">
			<div class="field col-12 md:col-6">
				<label>Nombre *</label>
				<input
					type="text"
					formControlName="name"
					pInputText
					class="w-full mb-3"
				/>
				<small
					class="p-error"
					*ngIf="
						form.get('name')!.errors &&
						form.get('name')!.touched &&
						form.get('name')!.hasError('required')
					"
					>Requerido</small
				>
			</div>
			<div class="field col-12 md:col-6">
				<label>Precio (€) *</label>
				<p-inputNumber
					formControlName="price"
					mode="decimal"
					thousandSeparator="."
					decimalSeparator=","
					[minFractionDigits]="2"
					[maxFractionDigits]="2"
					placeholder="1.234,56"
					></p-inputNumber>
				<small
					class="p-error"
					*ngIf="
						form.get('price')!.errors &&
						form.get('price')!.touched &&
						form.get('price')!.hasError('required')
					"
					>Requerido</small
				>
			</div>
			<div class="field col-12 md:col-9">
				<label>Descripción</label>
				<textarea
					type="text"
					formControlName="description"
					pInputText
					class="w-full mb-"
					maxlength="500"
				></textarea>
				<!-- <small class="p-text-secondary mb-3 text-right">
					{{ 500 - (form.get('description').value ? form.get('description').value.length : 0)}} / 500
				</small>
				<small
					class="p-error"
					*ngIf="
						form.get('description')!.errors &&
						form.get('description')!.touched &&
						form.get('description')!.hasError('required')
					"
					>Requerido</small
				> -->
			</div>
			<div class="field col-12 md:col-3">
				<div class="flex align-items-center">
					<p-checkbox formControlName="is_default"  [binary]="true" [value]="1" inputId="default" /> &nbsp;
					<label for="default">Seleccionado por defecto en reservas</label>
				</div>
			</div>
		</div>
	</form>
	<ng-template pTemplate="footer">
		<div class="flex justify-content-end col-12">
			<p-button
				styleClass="p-button-rounded"
				[label]="mode === 'register' ? 'Guardar' : 'Actualizar'"
				(click)="registerService()"
				[loading]="loading"
			>
			</p-button>
		</div>
	</ng-template>
</p-dialog>
